export default {
  upToPrice: {
    id: 'buyback_swap_v2_categories_up_to_price',
    defaultMessage: 'Up to {price}',
  },
  select: {
    id: 'buyback_swap_v2_categories_select',
    defaultMessage: 'Select a category',
  },
}
